import ElementContent from '@/components/sections/builder/elements/body/content-pages/content';
import ElementSetting from '@/components/sections/builder/elements/body/content-pages/setting';
import { ElementDataType } from '@/components/sections/builder/elements/body/content-pages/type';
import { DEFAULT_THEME_COLOR_SCHEME } from '@/components/sections/builder/theme/color';
import { TextSelect } from 'lucide-react';

const defaultData: ElementDataType = {
  name: 'Content Pages',
  colorBackgroundScheme: '',
  isShowSecondaryBackground: false,
  padding: {
    top: 20,
    bottom: 20,
    left: 20,
    right: 20,
  },
  colorSchemeCompanyContent: DEFAULT_THEME_COLOR_SCHEME,
};

export const ElementPreviewIcon = TextSelect;

const ContentPages = {
  type: 'content_pages',
  group: 'body_pages',
  defaultData,
  Element: ElementContent,
  Setting: ElementSetting,
  PreviewIcon: ElementPreviewIcon,
  defaultChilds: [],
  childs: [],
};

export default ContentPages;
